import * as CarePlanOperations from './CarePlans'
import * as ChargebeeOperations from './Chargebee'
import * as DataOperations from './Data'
import * as DocumentOperations from './Documents'
import * as EmarRoundTimingOperations from './EmarRoundTimings'
import * as FormOperations from './Forms'
import * as GlobalOperations from './Global'
import * as HandoverOperations from './Handovers'
import * as LogOperations from './Logs'
import * as ModalOperations from './Modals'
import * as ShiftOperations from './Shifts'
import * as TodoOperations from './Todos'
import * as UserOperations from './Users'

export default Object.assign(
  {},
  CarePlanOperations,
  ChargebeeOperations,
  DataOperations,
  DocumentOperations,
  EmarRoundTimingOperations,
  FormOperations,
  GlobalOperations,
  HandoverOperations,
  LogOperations,
  ModalOperations,
  ShiftOperations,
  TodoOperations,
  UserOperations
)
